import {Ed25519KeyIdentity} from '@dfinity/identity';

function fromHexString(hexString: string) {
  const match = hexString.match(/.{1,2}/g);

  if (match) {
    return new Uint8Array(match.map(byte => parseInt(byte, 16)));
  }
}

export function getIdentity(privateKey: string) {
  const value = fromHexString(privateKey);
  if (value) {
    return Ed25519KeyIdentity.generate(new Uint8Array(value));
  }
}
